import { createSimplePageStrategy } from './simple-page.strategy-helper';

export const HowItWorksSeoStrategy = createSimplePageStrategy(
  'howItWorks',
  'how-it-works',
  '/how-it-works'
);
